import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ForbiddenErrorComponent } from './forbidden-error.component';



@NgModule({
  declarations: [ForbiddenErrorComponent],
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    MessageModule,
    MessagesModule
  ]
})
export class ForbiddenErrorModule { }
